module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/multiple-properties-email-5c1a51f3ae88717136b66d482e93d406.svg";